import MaterialRecommendationPickerModal from './MaterialRecommendationPickerModal';

/** AI 灵感选图：与素材推荐共用同一套弹窗 UI，仅图库数据源不同 */
export default function AiInspirationPickerModal(props) {
  return <MaterialRecommendationPickerModal {...props} galleryKey="ai-inspiration" />;
}
